import type { CSSProperties, FC } from "react";
import { Spin } from "antd";
import { useTranslation } from "react-i18next";
import { CustomIcon } from "src/components/reusable/CustomIcon";
import type { User } from "../Types/UserTypes";

const DISABLED_ICON_STYLE: CSSProperties = { opacity: 0.5, cursor: "not-allowed" };

interface UserActionIconsProps {
  user: User;
  isDisabled: boolean;
  isDeleting: boolean;
  isArabic: boolean;
  onEdit: (_user: User) => void;
  onDelete: (_user: User) => void;
}

const UserActionIcons: FC<UserActionIconsProps> = ({
  user,
  isDisabled,
  isDeleting,
  isArabic,
  onEdit,
  onDelete,
}) => {
  const { t } = useTranslation();
  const lockedStyle = isDisabled ? DISABLED_ICON_STYLE : undefined;

  return (
    <div
      className="user-management-icons"
      style={{ display: "flex", gap: "8px", justifyContent: isArabic ? "center" : "flex-start" }}
    >
      <CustomIcon
        name="edit"
        tooltip={t("userManagement.actions.edit")}
        size={18}
        color="#141B34"
        style={lockedStyle}
        onClick={isDisabled ? undefined : () => onEdit(user)}
      />
      {isDeleting ? (
        <Spin size="small" />
      ) : (
        <CustomIcon
          name="delete"
          tooltip={t("userManagement.actions.delete")}
          size={18}
          color="#141B34"
          style={lockedStyle}
          onClick={isDisabled ? undefined : () => onDelete(user)}
        />
      )}
    </div>
  );
};

export default UserActionIcons;
